import React from 'react';
import { useHistory } from 'react-router-dom';
import { useOverlayContext, useStore, useStoreActions, useStoreStatic } from "../../contexts";
import { selectors } from "../../store/state-selectors";
import { AgreementStudioProposalMode } from "./AgreementStudioProposalMode";
import { DeclarativeModal } from 'seagull';
import { makeSentryIgnoredError } from "../ErrorBoundaryPage";
import { useOnMount } from "../../hooks/useOnMount";
import compact from 'lodash/compact';
export function useFetchAgreementStudioData() {
  const {
    fetchContacts,
    fetchAgreements,
    fetchProposals,
    fetchLegalTerms,
    fetchQboClasses,
    fetchFinancialCentsUsers,
    fetchKarbonUsers
  } = useStoreActions();
  const {
    startLoader,
    stopLoader
  } = useOverlayContext();
  const {
    getState
  } = useStoreStatic();
  return function fetchAgreementStudioData() {
    startLoader();
    const requests = compact([fetchLegalTerms(), fetchContacts(), fetchAgreements(), fetchProposals(), fetchQboClasses(), selectors.integration.showFinancialCentsIntegration(getState()) && fetchFinancialCentsUsers(), selectors.integration.showKarbonIntegration(getState()) && fetchKarbonUsers()]);
    Promise.all(requests).catch(() => {}).finally(() => stopLoader());
  };
}
export default function AgreementStudio(props) {
  const {
    returnRoute,
    draft,
    autoSaveTimeout,
    viewProposalMode,
    disableDataFetching,
    onClose
  } = props;
  const history = useHistory();
  const {
    fetchLegalTerms
  } = useStoreActions();
  const worksAt = useStore(selectors.user.business);
  const userEmail = useStore(selectors.user.email);
  const fetchAgreementStudioData = useFetchAgreementStudioData();
  useOnMount(() => {
    if (!disableDataFetching) {
      fetchAgreementStudioData();
    }
  });
  if (!worksAt || !userEmail) {
    throw makeSentryIgnoredError('noBusiness');
  }
  return /*#__PURE__*/React.createElement(DeclarativeModal, {
    isOpen: true,
    onClose: onClose,
    content: _ref => {
      let {
        dismissModal
      } = _ref;
      return /*#__PURE__*/React.createElement(AgreementStudioProposalMode, {
        autoSaveTimeout: autoSaveTimeout,
        viewProposalMode: viewProposalMode,
        draft: draft || null,
        worksAt: worksAt,
        userEmail: userEmail,
        onUploadLegalTermsDocument: fetchLegalTerms,
        onClose: () => {
          if (returnRoute) {
            if (history.location.pathname !== returnRoute) {
              history.push(returnRoute);
            }
          } else {
            history.goBack();
          }
          dismissModal();
        }
      });
    }
  });
}